import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';
import { Users, Activity } from 'lucide-react';

const Dashboard = () => {
  const [stats, setStats] = useState({
    tenants: 0,
    embeddings: 0,
    messages: 0
  });
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      setLoading(true);
      
      const tenantsResponse = await axios.get('/api/tenant/');
      const tenantsCount = tenantsResponse.data.length;
      setStats({
        tenants: tenantsCount,
        embeddings: 0,
        messages: 0
      });
    } catch (error) {
      console.error('Error fetching stats:', error);
      toast.error('Failed to load dashboard statistics');
    } finally {
      setLoading(false);
    }
  };

  const statCards = [
    { title: 'Total Tenants', value: stats.tenants, icon: Users, color: '#007bff' },
    { title: 'Chat Messages', value: stats.messages, icon: Activity, color: '#dc3545' }
  ];

  if (loading) {
    return (
      <div className="loading">
        <div>Loading dashboard...</div>
      </div>
    );
  }

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Dashboard</h1>
        <p className="page-subtitle">Overview of your chatbot system</p>
      </div>

      <div className="stats-grid">
        {statCards.map((stat, index) => {
          const Icon = stat.icon;
          return (
            <div key={index} className="stat-card">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <div className="stat-number">{stat.value}</div>
                  <div className="stat-label">{stat.title}</div>
                </div>
                <div style={{ color: stat.color }}>
                  <Icon size={32} />
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="card">
        <div className="card-header">
          <h3 className="card-title">Quick Actions</h3>
        </div>
        <div className="d-flex gap-3">
          <button className="btn btn-primary">
            Add New Tenant
          </button>
          <button 
            className="btn btn-secondary"
            onClick={() => navigate('/analytics')}
          >
            View Analytics
          </button>
        </div>
      </div>

      <div className="card">
        <div className="card-header">
          <h3 className="card-title">System Status</h3>
        </div>
        <div className="d-flex gap-3">
          <div className="badge badge-success">API Online</div>
          <div className="badge badge-success">Database Connected</div>
          <div className="badge badge-success">OpenAI Connected</div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
